module.exports = __webpack_public_path__ + "static/media/Vest.6436bfe9.PNG";